import appconfig from '@/utils/appConfig';
import { useField } from 'formik';
import clsx from 'clsx';
import { ErrorDisplay } from '@/components/formComponents/';

interface CheckboxProps {
    name: string;
    label: string;
}
const Checkbox = (props: CheckboxProps) => {
    const [field, meta] = useField(props.name);
    const { label } = props;

    const isInErrorState = meta.touched && meta.error;

    const checkboxClasses = clsx(
        'h-6',
        'w-6',
        'cursor-pointer',
        'rounded-md',
        'border-2',
        isInErrorState ? 'border-red-600' : `${appconfig.colors.primaryBorder}`,
        `${appconfig.colors.primaryBg}`,
        'text-gray-800',
        'focus:ring-gray-200',
        'mr-2'
    );

    return (
        <div className="mb-2">
            <label className="text-gray-500 font-bold flex items-center">
                <input
                    {...field}
                    checked={field.value}
                    className={checkboxClasses}
                    type="checkbox"
                />
                <span className="text-sm">{label}</span>
            </label>

            {isInErrorState && <ErrorDisplay meta={meta} />}
        </div>
    );
};

export default Checkbox;
